// Setting constants for sidebar list
export const TASK_LIST = 'taskList';
export const TASK_BOARD = 'taskBoard';
export const CREDENTIAL_LIST = 'credentialList';
export const PROJECT_TASK_LIST = 'projectTaskList';
export const PROJECT_TASK_BOARD = 'projectTaskBoard';
export const PROJECT_CREDENTIAL_LIST = 'projectCredentialList';

// Setting constants for status bar
export const USER_PAGE = 'userPage';
export const WORKLOAD_TABLE = 'workloadTable';
export const FREELANCER_TABLE = 'freelancerTable';
export const PROJECT_PAGE = 'projectPage';
export const CLIENT_TABLE = 'clientTable';
export const EVENT_TABLE = 'eventTable';
export const REPORT_PAGE = 'reportPage';
export const ARTICLE_PAGE = 'articlePage';
export const PROJECT_REPORT_PAGE = 'projectReportPage';
export const ARTICLE_LIST = 'articleList';

// Setting constants for notification drawer
export const NOTIFICATION_PROJECT_PANEL = 'notificationProjectPanel';
export const NOTIFICATION_TASK_PANEL = 'notificationTaskPanel';
export const NOTIFICATION_PANEL = 'notificationPanel';

// Setting constants for comment widget
export const COMMENT_WIDGET = 'commentWidget';

// Setting constants for TaskView
export const TASK_VIEW = 'taskView';

// Setting analytics
export const SERVICE_ANALYTICS = 'serviceAnalytics';

export const NAV_BAR = 'navBar';
